'use client'

import { AnalyticsBrowser } from '@segment/analytics-next'

type SegmentAnalytics = ReturnType<typeof AnalyticsBrowser.load>

let analytics: SegmentAnalytics | undefined

export function getAnalytics(): SegmentAnalytics | undefined {
  if (typeof window === 'undefined') return undefined
  if (!analytics) {
    const writeKey = process.env.NEXT_PUBLIC_SEGMENT_WRITE_KEY
    if (!writeKey) return undefined
    analytics = AnalyticsBrowser.load({ writeKey })
  }
  return analytics
}

export const trackEvent = (
  eventName: string,
  properties?: Record<string, unknown>,
) => {
  const analytics = getAnalytics()
  if (!analytics) return
  analytics.track(eventName, properties)
}
